import {useCallback} from 'react'
import type {MouseEvent} from 'react'
import {setStepsData} from 'src/redux/slices/tourPopupSlice'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {
  initialOnboardingTourSteps,
  isDeferredFreeTrialOnboardingUser,
} from 'src/utils/freeTrialDeferredOnboarding'

export const useFreeTrialDeferredOnboarding = () => {
  const dispatch = useAppDispatch()
  const {fetchedUserAccountData} = useAppSelector((state) => state.userAccountData)
  const {userCurrentSubscription} = useAppSelector((state) => state.pricing)

  const isDeferredFreeTrialOnboarding = isDeferredFreeTrialOnboardingUser(
    fetchedUserAccountData,
    userCurrentSubscription
  )

  const openOnboardingWizard = useCallback(() => {
    dispatch(
      setStepsData({
        stepData: initialOnboardingTourSteps,
        visible: true,
      })
    )
  }, [dispatch])

  const handleDeferredNavClick = useCallback(
    (event: MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()
      openOnboardingWizard()
    },
    [openOnboardingWizard]
  )

  return {
    isDeferredFreeTrialOnboarding,
    openOnboardingWizard,
    handleDeferredNavClick,
  }
}
